import BPButton from 'components/BionicUI/button/BPButton';
import BPCheckbox from 'components/BionicUI/checkbox/BPCheckbox';
import BPContainer from 'components/BionicUI/container/BPContainer';
import { useEffect, useState } from 'react';
import useOnboardingStore from 'stores/onboardingStore';
import { OnboardingEye } from '../Eye';
import InputBar from '../InputBar';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingSequence';
import BPPopup from 'components/BionicUI/popup/BPPopup';
import TermsDisplay from './TermsDisplay';

const TermsAgree = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const [showTermsPopup, setShowTermsPopup] = useState<boolean>(false);
  const [enableSubmit, setEnableSubmit] = useState<boolean>(false);
  const { nextStep, setProgressStep } = useOnboardingStore();

  useEffect(() => {
    setTimeout(() => setShowInputBar(true), 300);
  }, []);

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Please read and accept the Terms and Conditions before submitting your application...',
            sound: 'step1/please-read-accept-terms.mp3',
          }}
        >
          <div className="grid relative gap-8 pt-8">
            <BPCheckbox
              id="terms-agree"
              onChange={(checked) => setEnableSubmit(checked)}
            >
              I accept the{' '}
              <a href="#" onClick={() => setShowTermsPopup(true)}>
                Terms and Conditions
              </a>
            </BPCheckbox>
          </div>
        </BPInstruction>
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(4)}>
          <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
            <BPButton
              state="primary"
              disabled={!enableSubmit}
              onClick={nextStep}
            >
              Next
            </BPButton>
          </BPContainer>
        </InputBar>
      )}
      {showTermsPopup && (
        <BPPopup widthLimit={800} handleClose={() => setShowTermsPopup(false)}>
          <TermsDisplay />
        </BPPopup>
      )}
    </SequenceItem>
  );
};

export default TermsAgree;
